export default __webpack_public_path__ + "static/media/Medium's Leggings of Secret Doors.406adc58.jpg";